// Cross-realm-safe: the pre-2026-04-28 writer serialised cross-realm Dates
// as `{}` empty maps in Firestore; the toString-tag + NaN guard drops them.
export const isValidDate = (value: unknown): value is Date =>
  Object.prototype.toString.call(value) === '[object Date]' &&
  !Number.isNaN((value as Date).getTime());
